import { render, staticRenderFns } from "./EmailButton.vue?vue&type=template&id=a2e2b3b4&"
import script from "./EmailButton.vue?vue&type=script&lang=ts&"
export * from "./EmailButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports